import { useSortableTable } from './Hooks/useSortableTable';
import TableHead from './TableHead';
import TableBody from './TableBody';
import styles from './Table.module.scss';
import { useEffect } from 'react';

interface TableDataRow {
  [key: string]: any;
  email?: string;
  userId?: string;
}

interface Props {
  data: any;
  columns: {
    label: string;
    accessor: string;
    sortable: boolean;
    tooltip?: string;
    renderTooltip?: (data: TableDataRow) => string | null;
    clickable?: boolean | ((data: TableDataRow) => boolean);
    onClick?: (data: TableDataRow) => void;
  }[];
  totals?: any;
  defaultSortField?: string;
  defaultSortOrder?: 'asc' | 'desc';
}
const SortableTable = ({ columns, data, totals, defaultSortField, defaultSortOrder = 'asc' }: Props): JSX.Element => {
  const [tableData, handleSorting] = useSortableTable(data);
  useEffect(() => {
    defaultSortField && handleSorting(defaultSortField, defaultSortOrder);
  }, [data]);
  return (
    <table className={styles.tableContainer}>
      <TableHead columns={columns} handleSorting={handleSorting} />
      <TableBody columns={columns} tableData={tableData} totals={totals} />
    </table>
  );
};

export default SortableTable;
